import { render, staticRenderFns } from "./IconSvgGraduate.vue?vue&type=template&id=2e5135e6&scoped=true&"
import script from "./IconSvgGraduate.vue?vue&type=script&lang=js&"
export * from "./IconSvgGraduate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5135e6",
  null
  
)

export default component.exports